import styled from 'styled-components';

import theme from '@theme';

export const SearchBarItemWrapper = styled.div`
  padding: 0 8px 0 15px;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.palette.grey200};
  border-radius: 4px;
  display: flex;
  align-items: center;
  height: 56px;
  position: relative;
  background: ${({ theme }) => theme.palette.white};
  &:hover {
    border: 1px solid ${({ theme }) => theme.palette.black};
  }

  @media (max-width: ${theme.breakPoint.LARGE_1X}) {
    width: 100%;
  }
`;

export const SearchBarItemTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 95%;
  position: relative;
`;

export const SearchBarItemTitle = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 11px;
`;

export const SearchBarItemLabel = styled.div`
  padding-left: 12px;
  color: ${({ theme }) => theme.palette.grey1100};
  display: flex;
  align-items: center;
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  span {
    white-space: inherit;
    overflow: inherit;
    text-overflow: inherit;
  }
`;
